var _rect, _defs, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#C41220",
    width: 1920,
    height: 1080
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "objectBoundingBox",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "red"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#C41220;#061680;#0000ff;#C41220;#0E5DFF;#C41220;#C41220",
    dur: "20s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "purple"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#061680;#0000ff;#C41220;#0E5DFF;#C41220;#C41220;#061680",
    dur: "20s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "blue"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#0000ff;#C41220;#0E5DFF;#C41220;#C41220;#061680;#0000ff",
    dur: "20s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "gradientTransform",
    type: "rotate",
    from: "0 .5 .5",
    to: "360 .5 .5",
    dur: "20s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "objectBoundingBox",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "red"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#C41220;#061680;#0000ff;#C41220;#0E5DFF;#C41220;#C41220",
    dur: "20s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "purple",
    stopOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#061680;#0000ff;#C41220;#0E5DFF;#C41220;#C41220;#061680",
    dur: "20s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "gradientTransform",
    type: "rotate",
    values: "360 .5 .5;0 .5 .5",
    dur: "10s",
    repeatCount: "indefinite"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#a)",
    width: "100%",
    height: "100%"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#b)",
    fillOpacity: 0.1,
    width: "100%",
    height: "100%"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbow);
export default __webpack_public_path__ + "static/media/rainbow.49e81612cc82ef7932f257fa06afa192.svg";
export { ForwardRef as ReactComponent };